import axios from 'axios'
import * as auth from './auth'

const http = axios.create({
  baseURL: process.env.API_URL
})

http.interceptors.request.use(
  (request) => {
    request.headers['Authorization'] = 'Bearer ' + auth.getAccessToken()
    return request
  },
  (error) => Promise.reject(error)
)

http.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      auth.logout()
      if (window) {
        window.location.reload(true) // HACK: Forces to go to login page
      }
    }

    return Promise.reject(error)
  }
)

export default http



// WEBPACK FOOTER //
// ./src/utils/http.js